var DbApi;
(function (DbApi) {
    DbApi.PERIODIC_MIN_FROM = "2000-01-01T00:00:00Z";
    DbApi.PERIODIC_MAX_TO = "8999-12-31T00:00:00Z";
    let Snapshot;
    (function (Snapshot) {
        Snapshot._KIND = ["hourly", "fixed", "schedule"];
        Snapshot.KIND = Snapshot._KIND;
        Snapshot._TIME_KIND = ["absolute", "open"];
        Snapshot.TIME_KIND = Snapshot._TIME_KIND;
    })(Snapshot = DbApi.Snapshot || (DbApi.Snapshot = {}));
    let CameraNS;
    (function (CameraNS) {
        CameraNS.FEATURES = [
            "counter",
            "metacounter",
            "trackcounter",
            "facecounter",
            "heatmap",
            "heatmaps",
            "face",
            "groupFace",
            "dwellmap",
            "occupancy",
            "trafficmap",
            "zonetraffic",
            "directionmap",
            "flowmap",
            "rtFace",
            "zonetrace",
            "edgeFace",
            "trackingtree",
        ];
        /**
         * @deprecated use FEATURES
         */
        CameraNS.FEATURE = CameraNS.FEATURES;
        CameraNS.STAFF_EXCLUSION_ACQUISITION_KIND = ["daily", "none", "custom"];
    })(CameraNS = DbApi.CameraNS || (DbApi.CameraNS = {}));
    let Store;
    (function (Store) {
        Store.FEATURES = ["pathtree", "staytime"];
    })(Store = DbApi.Store || (DbApi.Store = {}));
    let Face;
    (function (Face) {
        const _CLOUD_PROCESSORS = ["face++", "awsface"];
        Face.CLOUD_PROCESSORS = _CLOUD_PROCESSORS;
        const _EDGE_PROCESSORS = [..._CLOUD_PROCESSORS, "edge"];
        Face.EDGE_PROCESSORS = _EDGE_PROCESSORS;
        const _ENGINE_KIND = ["dual", "edge"];
        Face.ENGINE_KIND = _ENGINE_KIND;
    })(Face = DbApi.Face || (DbApi.Face = {}));
    let Footfall;
    (function (Footfall) {
        Footfall.STANDARD_LABEL = [
            {
                key: "nolabel",
                _id: "f00000000000000000000000",
                name: "No Label",
                seedCounter: "No Label",
                i18nKey: "slabel_nolabel",
            },
            {
                key: "ot",
                _id: "f00000000000000000000001",
                name: "Outside Traffic",
                seedCounter: "Outside Traffic",
                i18nKey: "slabel_outsidetraffic",
            },
            {
                key: "entrance",
                _id: "f00000000000000000000002",
                name: "Entrance",
                seedCounter: "Footfall Entrance",
                i18nKey: "slabel_entrance",
            },
            {
                key: "exit",
                _id: "f00000000000000000000003",
                name: "Exit",
                seedCounter: "Exit",
                i18nKey: "slabel_exit",
            },
            {
                key: "nv",
                _id: "f00000000000000000000004",
                name: "Net Visits",
                seedCounter: "Net Visits",
                i18nKey: "slabel_netvisits",
            },
        ];
    })(Footfall = DbApi.Footfall || (DbApi.Footfall = {}));
})(DbApi || (DbApi = {}));
export default DbApi;
